<template>
    <div>
        <base-page-header :breadcrumb="breadcrumb" :title="entityName">
        </base-page-header>

        <v-form v-model="form.valide">
            <v-row class="bg-white p-3">
                <v-col cols="12">
                    <base-button-back class="p-0" @click="cancelAddEgar()">{{$t('back')}}</base-button-back>
                </v-col>
                <v-col cols="12" sm="4">
                    <v-autocomplete
                        :items="actorsSenders.length > 0? actorsSenders.map(el => ({text: el.description,value: el})) : []"
                        v-model="selectActorsSenders"
                        :rules="formInputs.default.rules"
                        filled
                        clearable
                        hide-details="auto"
                        :label="$t('environmental-management.egar.new-egar-form.intervening-type-req')"
                    ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="4">
                    <v-autocomplete
                    :items="actorsSenderTypes.length > 0? actorsSenderTypes.map(el => ({text: el.description,value: el})) : []"
                    v-model="selectActorsSendersType"
                    clearable
                    filled
                    hide-details="auto"
                    :rules="formInputs.default.rules"
                    :label="$t('environmental-management.egar.new-egar-form.perfil-type-req')"
                    ></v-autocomplete>
                </v-col>

                <v-col cols="12">
                    <hr>
                </v-col>
                <v-col cols="12">
                    <h3>{{$t('environmental-management.egar.new-egar-form.operator-h3')}}</h3>
                </v-col>
                <v-col cols="12" sm="4">
                    <v-combobox
                        clearable
                        filled
                        v-model="form.recipientEstablishment.nif"
                        :items="[userAuth.nif.substr(2)]"
                        :rules="formInputs.nif.rules"
                        hide-details="auto"
                        :label="$t('environmental-management.egar.new-egar-form.nif-ogr-req')"
                        @change="getRecipientEstablishmentNif()"
                    ></v-combobox>
                </v-col>
                <v-col cols="12" sm="4">
                    <v-select
                        v-if="recipientsEstablishment.length > 0"
                        v-model="selectRecipientEstablishment"
                        :items="recipientsEstablishment.length > 0? recipientsEstablishment.map(el => ({text: el.name,value: el})) : []"
                        :rules="formInputs.default.rules"
                        filled
                        hide-details="auto"
                        :label="$t('environmental-management.egar.new-egar-form.establishments-req')"
                        :menu-props="{ top: false, offsetY: true }"
                    ></v-select>
                </v-col>

                <v-col cols="12" sm="3" class="d-flex align-center">
                    <v-btn small v-if="recipientsEstablishment.length > 0" @click="obterRecipient"> {{$t('environmental-management.egar.new-egar-form.get-establishments')}} </v-btn>
                </v-col>

                <v-col cols="12">
                    <hr>
                </v-col>


                <v-col cols="12">
                    <h3>{{$t('environmental-management.egar.new-egar-form.transporter-h3')}}</h3>
                </v-col>

                <v-col cols="12" sm="2">
                    <v-text-field
                    filled
                    v-model="form.transported.nif"
                    @change="getTransporter()"
                    hide-details="auto"
                    :rules="formInputs.nif.rules"
                    :label="$t('environmental-management.egar.new-egar-form.nif-transporter-req')"
                    ></v-text-field>
                </v-col>

                <v-col cols="12" sm="3">
                    <v-text-field
                    filled
                    v-model="form.transported.name"
                    :rules="formInputs.default.rules"
                    hide-details="auto"
                    :label="$t('environmental-management.egar.new-egar-form.transporter-req')"
                    ></v-text-field>
                </v-col>

                <v-col cols="12" sm="1">
                    <v-text-field
                        filled
                        v-model="form.transported.order"
                        :rules="formInputs.default.rules"
                        hide-details="auto"
                        :label="$t('environmental-management.egar.new-egar-form.order-req')"
                    ></v-text-field>
                </v-col>

                <v-col cols="12" sm="2">
                    <v-text-field
                        filled
                        v-model="form.transported.plateNumber"
                        hide-details="auto"
                        :label="$t('environmental-management.egar.new-egar-form.registration')"
                    ></v-text-field>
                </v-col>

                <v-col cols="12" sm="2">
                    <v-menu
                        ref="menuDate"
                        v-model="menuDate"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="auto"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="form.transported.data"
                                :rules="formInputs.default.rules"
                                :label="$t('environmental-management.egar.new-egar-form.transporter-date-init-req')"
                                persistent-hint
                                v-bind="attrs"
                                append-icon="mdi-calendar"
                                filled
                                v-on="on"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="form.transported.data"
                            no-title
                            @input="menuDate = false"
                        >
                            <v-spacer></v-spacer>
                            <v-btn
                                text
                                class="primary-button"
                                @click="menuDate = false"
                            >
                                {{$t('cancel')}}
                            </v-btn>
                            <v-btn
                                text
                                class="primary-button"
                                @click="$refs.menuDate.save(form.transported.data)"
                            >
                                {{$t('ok')}}
                            </v-btn>
                        </v-date-picker>
                    </v-menu>
                </v-col>

                <v-col cols="12" sm="2">
                    <v-dialog
                        ref="dialog"
                        v-model="allowableWasteOfTimeModal"
                        :return-value.sync="form.transported.hours"
                        persistent
                        width="290px"
                    >
                        <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="form.transported.hours"
                            :label="$t('environmental-management.egar.new-egar-form.transporter-hour-init')"
                            append-icon="mdi-clock-time-four-outline"
                            readonly
                            filled
                            v-bind="attrs"
                            v-on="on"
                        ></v-text-field>
                        </template>
                        <v-time-picker
                            v-if="allowableWasteOfTimeModal"
                            v-model="form.transported.hours"
                            full-width
                            format="24hr"
                        >
                        <v-spacer></v-spacer>
                        <v-btn
                            text
                            class="primary-button"
                            @click="allowableWasteOfTimeModal = false"
                        >
                            {{$t('cancel')}}
                        </v-btn>
                        <v-btn
                            text
                            class="primary-button"
                            @click="$refs.dialog.save(form.transported.hours)"
                        >
                            {{$t('ok')}}
                        </v-btn>
                        </v-time-picker>
                    </v-dialog>
                </v-col>

                <v-col cols="12">
                    <hr>
                </v-col>
                <v-col cols="12">
                    <h3>{{ $t('environmental-management.egar.headers.producer') }}</h3>
                </v-col>

                <v-col cols="12" sm="2">
                    <v-text-field
                    filled
                    v-model="form.producerEstablishment.nif"
                    @blur="getProducersEstablishmentNif()"
                    hide-details="auto"
                    :rules="formInputs.nif.rules"
                    :label="$t('environmental-management.egar.new-egar-form.producer-nif-req')"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" sm="2">
                    <v-select
                    v-model="form.producerType"
                    :items="producerType.length > 0? producerType.map(el => ({text: el.description,value: +el.producerTypeId})) : []"
                    :rules="formInputs.default.rules"
                    filled
                    hide-details="auto"
                    :label="$t('environmental-management.egar.new-egar-form.type-req')"
                    :menu-props="{ top: false, offsetY: true }"
                    ></v-select>
                </v-col>
                <v-col cols="12" sm="5">
                    <v-select
                    v-model="selectProducerEstablishment"
                    :items="producersEstablishment.length > 0? producersEstablishment.map(el => ({text: el.name,value: el})) : []"
                    :rules="formInputs.default.rules"
                    filled
                    hide-details="auto"
                    :label="$t('environmental-management.egar.new-egar-form.establishments-req')"
                    :menu-props="{ top: false, offsetY: true }"
                    ></v-select>
                </v-col>

                <v-col cols="12" sm="3" class="d-flex align-center">
                    <v-btn small v-if="producersEstablishment.length > 0" @click="obterProducer"> {{$t('environmental-management.egar.new-egar-form.get-establishments')}} </v-btn>
                </v-col>

                <v-col cols="12" sm="4">
                    <v-text-field
                    v-model="form.producerEstablishment.address"
                    filled
                    :rules="formInputs.default.rules"
                    hide-details="auto"
                    readonly
                    :label="$t('environmental-management.egar.new-egar-form.adress-req')"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" sm="4">
                    <v-text-field
                    v-model="form.producerEstablishment.postalCode"
                    filled
                    hide-details="auto"
                    :rules="formInputs.default.rules"
                    readonly
                    :label="$t('environmental-management.egar.new-egar-form.postal-code-req')"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" sm="4">
                    <v-text-field
                    v-model="form.producerEstablishment.locality"
                    filled
                    hide-details="auto"
                    :rules="formInputs.default.rules"
                    readonly
                    :label="$t('environmental-management.egar.new-egar-form.locale-req')"
                    ></v-text-field>
                </v-col>

                <v-col cols="12">
                    <hr>
                </v-col>

                <v-col cols="12">
                    <h3>{{$t('environmental-management.egar.new-egar-form.leavings-h3')}}</h3>
                </v-col>
                <v-col cols="12" v-for="(residuo, index) in form.residuos" :key="index">
                    <v-row>
                        <v-col cols="12" sm="4">
                            <v-autocomplete
                            :items="lerCodes.length > 0? lerCodes.map(el => ({text: el.description, value: el.lerCodeId})) : []"
                            :rules="formInputs.default.rules"
                            filled
                            @change="getOperationCodes(residuo.lerCodeId, index, residuo)"
                            v-model="residuo.lerCodeId"
                            hide-details="auto"
                            :label="$t('environmental-management.egar.new-egar-form.designation-leavings-req')"
                            ></v-autocomplete>

                        </v-col>
                        <v-col cols="12" sm="3">
                            <v-text-field
                            v-model="residuo.codigoLer"
                            :rules="formInputs.default.rules"
                            filled
                            hide-details="auto"
                            :label="$t('environmental-management.egar.new-egar-form.ler-code-req')"
                            readonly
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="2">
                            <v-autocomplete
                            :items="operationCodes.length > 0? operationCodes.map(el => ({text: el.operationCode,value: +el.operationCodeID})) : []"
                            v-model="residuo.operationCodeId"
                            @change="changeOperationCode(index)"
                            :rules="formInputs.default.rules"
                            filled
                            hide-details="auto"
                            :label="$t('environmental-management.egar.new-egar-form.operation-code-req')"
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="2">
                            <v-text-field
                            v-model="residuo.quantity"
                            :rules="formInputs.default.rules"
                            filled
                            hide-details="auto"
                            :label="$t('environmental-management.egar.new-egar-form.qtd-req')"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </v-col>


                <v-col cols="12" class="mx-auto text-center">
                    <v-btn class="btn-primary-custom btn-red mr-md-3 mr-0 mb-3 mb-md-0" text @click="cancelAddEgar()">
                        {{$t('cancel')}}
                    </v-btn>
                    <!--<v-btn rounded class="btn-primary-custom btn-grey mr-md-3 mr-0 mb-3 mb-md-0" @click="saveEgar(1)" :disabled="!form.valide">Gravar</v-btn>-->
                    <v-btn rounded class="btn-primary-custom" @click="saveEgar()" :disabled="!form.valide">{{$t('environmental-management.egar.new-egar-form.emitt')}}</v-btn>
                </v-col>
            </v-row>
        </v-form>

        <!-- Modal Alerts. -->
        <base-modal v-model="modalAlert.show" modalAlign="align__flex--center" :title="modalAlert.title" modal-width="460px" :iconColor="modalAlert.iconColor" :iconName="modalAlert.iconName">
            <template v-slot:modal-close>
                <div @click="closeModalAlert()">
                    <img src="/images/_SVGs/environmental/fechar.svg" onload="SVGInject(this)" width="20" height="20" />
                </div>
            </template>

            <template v-slot:modal-body>
                {{modalAlert.message}}
            </template>

            <template v-slot:modal-actions>

                <div class="ml-2">
                    <v-btn text :class="modalAlert.iconColor == 'warning' ? 'danger-button' : 'primary-button'"  @click="closeModalAlert()">
                        <span style="text-transform: capitalize">{{$t('ok')}}</span>
                    </v-btn>
                </div>
            </template>
        </base-modal>
    </div>
</template>

<script>
    import { GetEstablishment, GetProducerTypes,GetLerCode, GetOperationCode, GetActorsSenders, GetTransporterNif, GetEgarPreFilled} from '@services/b2b/environmental-management/EgarService';
    import { CreateEgar } from '@services/b2b/environmental-management/EgarManagementService';
    import { required, maxLength, minLength } from '@src/utils/validations.js';
    import BaseModal from "@components/shared/widgets/BaseModal.vue";
    import BaseButtonBack from "@components/shared/widgets/BaseButtonBack.vue";
    import BasePageHeader from "@components/shared/widgets/pages-header/BasePageHeader.vue";
    export default {
        components: {BasePageHeader, BaseButtonBack, BaseModal},
        data(){
            return{
                modalAlert: {
                    show: false,
                    title: '',
                    message: '',
                    iconName: '',
                    iconColor: '',
                    buttonRedirect: false,
                },

                menuDate: false,
                breadcrumb: [
                    {
                        title: this.$t('environmental-management.title'),
                        routerLinkName: 'environmentalManagement'
                    },
                    {
                        title: this.$t('environmental-management.egar.title'),
                        routerLinkName: 'environmentalManagementEGAR'
                    },
                    {
                        title: this.$t('environmental-management.egar.new-egar'),
                    }
                ],

                lerCodes:[],
                operationCodes: [],
                entityName: this.$t('environmental-management.egar.new-egar-form.entity-name'),
                formInputs: {
                    default: {
                        rules: [required]
                    },
                    nif: {
                        rules: [required, minLength(9),maxLength(9)]
                    },

                },
                form: {
                    valide: false,
                    producerType: 0,
                    producerEstablishment: {
                        nif: '',
                        name: '',
                        address: '',
                        postalCode: '',
                        locality: '',
                        apaCode: ''
                    },
                    recipientEstablishment: {
                        nif: "",
                        name: "",
                        address: "",
                        postalCode: "",
                        locality: "",
                        apaCode: ""
                    },
                    residuos: [{
                        designation: "",
                        lerCodeId: "",
                        operationCodeId: 0,
                        quantity: 0,
                        groupCode: "",
                        numberPgl: ""
                    }],
                    transported: {
                        nif: '',
                        name: '',
                        order: 1,
                        plateNumber: '',
                        data: null,
                        hours: ''
                    },
                },
                allowableWasteOfTimeModal: false,
                producersEstablishment: [],
                selectProducerEstablishment: [],
                producerType: [],
                recipientsEstablishment: [],
                selectRecipientEstablishment: null,
                actorsSenders: [],
                selectActorsSenders: null,
                actorsSenderTypes: [],
                selectActorsSendersType: null,
                selectLerCode: null,
                selectOperationCode: null,
                dados: [],
                isRefreshProducers: false,
                isRefreshRecipient: false
            }
        },
        computed: {
            userAuth() {
                return  this.$store.getters['auth/getState'];
            },
        },
        watch: {
            selectProducerEstablishment: {
                handler: function(newValue, oldValue) {
                    if(newValue.apaCode){
                        this.form.producerEstablishment.apaCode= newValue.apaCode
                        this.form.producerEstablishment.authorizeIssuance= newValue.authorizeIssuance
                        this.form.producerEstablishment.address= newValue.headquartersAddress
                        this.form.producerEstablishment.locality= newValue.headquartersLocality
                        this.form.producerEstablishment.postalCode= newValue.headquartersPostalCode
                        this.form.producerEstablishment.name= newValue.name
                    }
                },
                immediate: false,
                deep: true
            },
            selectRecipientEstablishment: {
                handler: function(newValue, oldValue) {
                    if(newValue.apaCode){
                        this.form.recipientEstablishment.apaCode= newValue.apaCode
                        this.form.recipientEstablishment.authorizeIssuance= newValue.authorizeIssuance
                        this.form.recipientEstablishment.address= newValue.headquartersAddress
                        this.form.recipientEstablishment.locality= newValue.headquartersLocality
                        this.form.recipientEstablishment.postalCode= newValue.headquartersPostalCode
                        this.form.recipientEstablishment.name= newValue.name
                    }
                },
                immediate: false,
                deep: true
            },
            selectActorsSenders:{
                handler: function(newValue, oldValue) {
                    if(newValue.sendersType){
                        this.actorsSenderTypes = newValue.sendersType
                    }
                },
                immediate: false,
                deep: true
            },
        },
        methods:{
            cancelAddEgar(){
                this.$router.push({name: "environmentalManagementEGAR"})
            },
            getTransporter(){
                this.$store.commit('loadings/setStateLoadingTemplate', true);

                return GetTransporterNif(this.form.transported.nif)
                    .then(response => {
                        this.form.transported.name = response.data.result.name

                        this.form.transported.plateNumber = response.data.result.plateNumber
                    })
                    .catch(error => {
                        this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                        throw new Error('error to get getTransporter values', error);
                    })
                    .finally(() => {
                        this.$store.commit('loadings/setStateLoadingTemplate', false);
                    })
            },
            changeOperationCode(index){
                if(this.form.residuos[index].operationCodeId){
                    this.operationCodes.map(el =>
                    {
                        if(el.operationCodeID == this.form.residuos[index].operationCodeId){
                            this.form.residuos[index].groupCode = el.operationCode
                            this.form.residuos[index].operationCode = el.operationCode
                            this.form.residuos[index].numberPgl = el.averageWeight
                        }

                    })
                }
            },
            closeModalAlert(){
                this.$store.commit('loadings/setStateLoadingTemplate', true);
                this.modalAlert.show = false;

                if(this.modalAlert.buttonRedirect){
                    this.$router.push({name: "environmentalManagementEGAR"})
                }
                this.$store.commit('loadings/setStateLoadingTemplate', false);

            },

            obterProducer(){
                this.isRefreshProducers = true;
                this.getProducersEstablishmentNif()
            },
            getProducersEstablishmentNif(){
                this.selectProducerEstablishment = [];
                this.form.producerEstablishment.name = ''
                this.form.producerEstablishment.address = ''
                this.form.producerEstablishment.postalCode = ''
                this.form.producerEstablishment.locality = ''
                this.form.producerEstablishment.apaCode = ''

                let filter = {
                    nif: null,
                    isRefresh: this.isRefreshProducers
                };
                if(this.form.producerEstablishment.nif){
                    if(this.form.producerEstablishment.nif.length < 9){
                        return
                    }
                    filter = {
                        nif: this.form.producerEstablishment.nif,
                        isRefresh: this.isRefreshProducers
                    }
                }

                if(filter.nif){
                    this.$store.commit('loadings/setStateLoadingTemplate', true);

                    return GetEstablishment(filter)
                        .then(response => {
                            if(response.data.result.length > 0){
                                this.producersEstablishment = response.data.result
                                if(this.dados){
                                    this.selectProducerEstablishment = response.data.result.filter(el => el.apaCode == this.dados.sender.establishment.apaCode)[0]

                                }else{
                                    this.selectProducerEstablishment = this.producersEstablishment[0]
                                }
                            }else{
                                this.modalAlert.message = this.$t('environmental-management.egar.new-egar-form.modal-alert.msg1'),
                                this.modalAlert.title = this.$t('heads-up')
                                this.modalAlert.iconName = 'mdi-alert-outline';
                                this.modalAlert.iconColor = 'warning';
                                this.modalAlert.show = true;
                            }
                        })
                        .catch(error => {
                            this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                            throw new Error('error to get GetEstablishment egar values', error);
                        })
                        .finally(() => {
                            this.isRefreshProducers = false;
                            this.$store.commit('loadings/setStateLoadingTemplate', false);
                        })
                }
                return
            },
            obterRecipient(){
                this.isRefreshRecipient = true;
                this.getRecipientEstablishmentNif()
            },
            getRecipientEstablishmentNif(){
                this.selectRecipientEstablishment = [];
                this.form.recipientEstablishment.name = ''
                this.form.recipientEstablishment.address = ''
                this.form.recipientEstablishment.postalCode = ''
                this.form.recipientEstablishment.locality = ''
                this.form.recipientEstablishment.apaCode = ''
                this.recipientsEstablishment = [];
                let filter = {
                    nif: null,
                    isRefresh: this.isRefreshRecipient
                };
                if(this.form.recipientEstablishment.nif){
                    if(this.form.recipientEstablishment.nif.length < 9){
                        return
                    }
                    filter = {
                        nif: this.form.recipientEstablishment.nif,
                        isRefresh: this.isRefreshRecipient
                    }
                }

                if(filter.nif){
                    this.$store.commit('loadings/setStateLoadingTemplate', true);

                    return GetEstablishment(filter)
                        .then(response => {
                            if(response.data.result.length > 0){
                                this.recipientsEstablishment = response.data.result
                                if(this.dados){
                                    this.selectRecipientEstablishment = response.data.result.filter(el => el.apaCode == this.dados.recipient.establishment.apaCode)[0]

                                }else{
                                    this.selectRecipientEstablishment = response.data.result[0]
                                }
                            }else{
                                this.form.recipientEstablishment.nif = ''
                                this.modalAlert.message = this.$t('environmental-management.egar.new-egar-form.modal-alert.msg2'),
                                this.modalAlert.title = this.$t('heads-up')
                                this.modalAlert.iconName = 'mdi-alert-outline';
                                this.modalAlert.iconColor = 'warning';
                                this.modalAlert.show = true;
                            }
                        })
                        .catch(error => {
                            this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);

                            this.form.recipientEstablishment.nif = ''
                            this.modalAlert.message = this.$t('environmental-management.egar.new-egar-form.modal-alert.msg2'),
                            this.modalAlert.title = this.$t('heads-up')
                            this.modalAlert.iconName = 'mdi-alert-outline';
                            this.modalAlert.iconColor = 'warning';
                            this.modalAlert.show = true;
                            this.form.recipientEstablishment.nif = ''
                            throw new Error('error to get GetEstablishment egar values', error);
                        })
                        .finally(() => {
                            this.isRefreshRecipient = false;
                            this.$store.commit('loadings/setStateLoadingTemplate', false);
                        })
                }
                return
            },
            getTypeProducer(){
                if(this.producerType.length == 0){
                    this.$store.commit('loadings/setStateLoadingTemplate', true);

                    return GetProducerTypes()
                        .then(response => {
                            this.producerType = response.data.result
                            if(this.dados){
                                this.form.producerType = this.producerType.filter(el => el.code == this.dados.producerType)[0].producerTypeId;

                            }

                        })
                        .catch(error => {
                            this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                            throw new Error('error to get GetProducerTypes egar values', error);
                        })
                        .finally(() => {
                            this.$store.commit('loadings/setStateLoadingTemplate', false);
                            this.getLerCodes()
                        })
                }

                this.getLerCodes()
            },
            getLerCodes(){
                if(this.lerCodes.length == 0){
                    this.$store.commit('loadings/setStateLoadingTemplate', true);

                    return GetLerCode()
                        .then(response => {
                            this.lerCodes = response.data.result
                        })
                        .catch(error => {
                            this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                            throw new Error('error to get GetLerCode values', error);
                        })
                        .finally(() => {
                            this.$store.commit('loadings/setStateLoadingTemplate', false);
                            this.getActorsSender()
                        })
                }
                this.getActorsSender()
            },
            getOperationCodes(lerCode, index, residuo){
                this.$store.commit('loadings/setStateLoadingTemplate', true);
                const lerCodes = _.cloneDeep(this.lerCodes)
                residuo.codigoLer = lerCodes.filter(el => el.lerCodeId == residuo.lerCodeId)[0].lerCode
                residuo.designation = lerCodes.filter(el => el.lerCodeId == residuo.lerCodeId)[0].description
                return GetOperationCode(lerCode)
                    .then(response => {
                        if(response.data.result.length > 0){
                            this.operationCodes = response.data.result
                            residuo.operationCodeId = response.data.result? response.data.result[0].operationCodeID : null

                            const findR12 = response.data.result.filter(elem => elem.operationCode == 'R12');
                            if(findR12 && findR12.length > 0) {
                                residuo.operationCodeId = findR12[0].operationCodeID;
                            }
                        }
                    })
                    .catch(error => {
                        this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                        throw new Error('error to get GetLerCode values', error);
                    })
                    .finally(() => {
                        this.$store.commit('loadings/setStateLoadingTemplate', false);
                    })

            },
            getActorsSender(){
                if(this.actorsSenders.length == 0){
                    this.$store.commit('loadings/setStateLoadingTemplate', true);

                    return GetActorsSenders()
                        .then(response => {
                            if(response.data.result.length > 0){
                                this.actorsSenders = response.data.result
                            }
                        })
                        .catch(error => {
                            this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                            throw new Error('error to get GetActorsSenders values', error);
                        })
                        .finally(() => {
                            this.$store.commit('loadings/setStateLoadingTemplate', false);
                            this.getDados()
                        })
                }
                this.getDados()
            },
            saveEgar(){

                this.$store.commit('loadings/setStateLoadingTemplate', true);

                let transporterDateTime = this.form.transported.data +'T'+ this.form.transported.hours+':00.0000'

                if(new Date(transporterDateTime) < new Date()){
                    this.modalAlert.message = this.$t('environmental-management.egar.new-egar-form.modal-alert.msg3'),
                    this.modalAlert.title = this.$t('heads-up')
                    this.modalAlert.iconName = 'mdi-alert-outline';
                    this.modalAlert.iconColor = 'warning';
                    this.modalAlert.show = true;

                    this.$store.commit('loadings/setStateLoadingTemplate', false);
                    return;
                }
                let body = {
                    "interveningNif": this.selectActorsSenders.actorTypeID == 1 ? this.form.producerEstablishment.nif : this.form.recipientEstablishment.nif,
                    "egar": {
                        "producerTypeId": this.form.producerType,
                        "sender": {
                            "nif": this.form.producerEstablishment.nif,
                            "senderTypeId": this.selectActorsSendersType.senderTypeID,
                            "establishmentApaCode": this.form.producerEstablishment.apaCode
                        },
                        "recipient": {
                            "nif": this.form.recipientEstablishment.nif,
                            "apaCode": this.form.recipientEstablishment.apaCode
                        },
                        "transporters": {
                            "nif": this.form.transported.nif,
                            "plateNumber": this.form.transported.plateNumber,
                            "transportationStartDateTime": transporterDateTime,
                            "orderNumber": this.form.transported.order
                        },
                        "tranportedResidue": {
                            "designation": this.form.residuos[0].designation,
                            "residueLerCode": this.form.residuos[0].codigoLer,
                            "operationCode": this.operationCodes.filter(el => el.operationCodeID == this.form.residuos[0].operationCodeId)[0].operationCode,
                            "quantity": this.form.residuos[0].quantity,
                        }
                    },
                    "interveningTypeId": this.selectActorsSenders.actorTypeID
                }

                return CreateEgar(body)
                .then(response => {
                    if(response.data.result){

                        this.modalAlert.message = this.$t('environmental-management.egar.new-egar-form.modal-alert.msg4'),
                        this.modalAlert.title = this.$t('heads-up')
                        this.modalAlert.show = true;
                        this.modalAlert.buttonRedirect = true

                    }else{
                        this.modalAlert.message = this.$t('environmental-management.egar.new-egar-form.modal-alert.msg5'),
                        this.modalAlert.title = this.$t('heads-up')
                        this.modalAlert.iconName = 'mdi-alert-outline';
                        this.modalAlert.iconColor = 'warning';
                        this.modalAlert.show = true;
                    }
                })
                .catch(error => {
                    this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);

                    this.form.recipientEstablishment.nif = ''
                    this.modalAlert.message = this.$t('environmental-management.egar.new-egar-form.modal-alert.msg5'),
                    this.modalAlert.title = this.$t('heads-up')
                    this.modalAlert.iconName = 'mdi-alert-outline';
                    this.modalAlert.iconColor = 'warning';
                    this.modalAlert.show = true;
                    throw new Error('error to get CreateEgar values', error);
                })
                .finally(() => {
                    this.$store.commit('loadings/setStateLoadingTemplate', false);
                })
            },
            getDados(){

                if(this.dados){
                    this.producersEstablishment = [{
                        apaCode: this.dados.sender.establishment.apaCode,
                        headquartersAddress:this.dados.sender.address,
                        headquartersLocality: this.dados.sender.locality,
                        headquartersPostalCode: this.dados.sender.postalCode,
                        name:this.dados.sender.name,
                        nif: this.dados.sender.nif
                    }]
                    this.form = {
                        valide: true,
                        producerType: 0,
                        producerEstablishment: {
                            nif: this.dados.sender.nif,
                            name: this.dados.sender.name,
                            address: this.dados.sender.address,
                            postalCode: this.dados.sender.postalCode,
                            locality: this.dados.sender.locality,
                            apaCode: this.dados.sender.establishment.apaCode
                        },
                        recipientEstablishment: {
                            nif: '',
                            name: '',
                            address: '',
                            postalCode: '',
                            locality: '',
                            apaCode: ''
                        },
                        residuos: [{
                            designation: this.dados.transportedResidue? this.dados.transportedResidue.designation : this.dados.tranportedResidue.designation,
                            lerCodeId: this.dados.transportedResidue? +this.dados.transportedResidue.residueLerCode : this.dados.tranportedResidue.residueLerCode,
                            operationCodeId: this.dados.transportedResidue? this.dados.transportedResidue.operationCode : this.dados.tranportedResidue.operationCode,
                            quantity: this.dados.transportedResidue? Math.round(this.dados.transportedResidue.quantity) : Math.round(this.dados.tranportedResidue.quantity),
                        }],
                        transported: {
                            nif: this.dados.tranporters? this.dados.tranporters.nif : this.dados.transporters.nif,
                            name: this.dados.tranporters? this.dados.tranporters.name : this.dados.transporters.name,
                            order: 1,
                            plateNumber: this.dados.tranporters? this.dados.tranporters.plateNumber : this.dados.transporters.plateNumber,
                            data: null,
                            hours: ''
                        },
                    };
                    var actorCode = this.actorsSenders.find(el => el.code == this.dados.actorCode);
                    this.selectActorsSenders = actorCode ? actorCode : this.actorsSenders[0];
                    this.actorsSenderTypes = this.selectActorsSenders.sendersType;


                    this.selectActorsSendersType = this.actorsSenderTypes.filter( el => el.code == this.dados.sender.senderType)[0];

                    this.form.producerType = +this.producerType.filter(el => el.code == this.dados.producerType)[0].producerTypeId;

                    this.form.recipientEstablishment = this.dados.recipient

                    let transportedResidue = null
                    if(this.dados.transportedResidue){
                        transportedResidue = this.dados.transportedResidue
                    }else{
                        transportedResidue = this.dados.tranportedResidue
                    }

                    this.form.residuos[0].lerCodeId = this.lerCodes.filter(el => el.lerCode == transportedResidue.residueLerCode)[0].lerCodeId;
                    this.form.residuos[0].designation = this.lerCodes.filter(el => el.lerCode == transportedResidue.residueLerCode)[0].description;

                    this.form.residuos[0].codigoLer = this.lerCodes.filter(el => el.lerCode == transportedResidue.residueLerCode)[0].lerCode;

                    this.form.residuos[0].operationCodeId = transportedResidue.operationCode
                    this.getOperationCodes(this.form.residuos[0].lerCodeId, 0 , this.form.residuos[0])

                    this.selectRecipientEstablishment = this.dados.recipient

                    this.getProducersEstablishmentNif()
                    this.getRecipientEstablishmentNif()
                }
            },
            getEgarPreFilled(){
                this.$store.commit('loadings/setStateLoadingTemplate', true);
                return GetEgarPreFilled()
                .then(response => {
                    this.form.producerEstablishment.nif = response.data.result.producerNif
                    this.producersEstablishment = response.data.result.producerEstablishments.map(el => {
                        return {
                            apaCode: el.apaCode,
                            authorizeIssuance: true,
                            headquartersAddress: el.fullName,
                            headquartersLocality: el.locality,
                            headquartersPostalCode: el.postalCode,
                            name: el.name,
                            nif: response.data.result.producerNif,
                        }
                    })

                    this.recipientsEstablishment = response.data.result.recipientEstablishments.map(el => {
                        return {
                            apaCode: el.apaCode,
                            authorizeIssuance: true,
                            headquartersAddress: el.fullName,
                            headquartersLocality: el.locality,
                            headquartersPostalCode: el.postalCode,
                            name: el.name,
                            nif: response.data.result.recipientNif,
                        }
                    })

                    this.selectRecipientEstablishment = this.recipientsEstablishment[0]
                    this.form.recipientEstablishment.nif = response.data.result.recipientNif


                })
                .catch(error => {
                    this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                    throw new Error('error to get egar values', error);
                })
                .finally(() => {
                    this.$store.commit('loadings/setStateLoadingTemplate', false);
                })
            },
        },

        mounted() {
            if(!this.userAuth.isAdminSILiAmb){
                this.getEgarPreFilled()
            }
            this.dados = this.$route.params.egar;

            this.getTypeProducer()
            this.entityName = 'Novo e-GAR';
        }
    }
</script>

<style lang="scss" scoped>

@import '@sass/_variables.scss';
.btn-red{
    border-radius: 28px;
    background: $red;
}
</style>
